/**
 * @fileoverview Model representing a Matched Listing.
 *
 * @author Kuber Sethi(ksethi@yext.com)
 */
export class MatchedListing {
  /**
   * @param {{
   *  entityId: number?,
   *  groupId: string?,
   *  externalId: string?,
   *  displayAddress: string,
   *  isVerified: boolean,
   * }} params
   */
  constructor(params) {
    /** @type {number?} */
    this.entityId = params.entityId;
    /** @type {string?} */
    this.groupId = params.groupId;
    /** @type {string?} */
    this.externalId = params.externalId;
    /** @type {string} */
    this.displayAddress = params.displayAddress;
    /** @type {boolean} */
    this.isVerified = params.isVerified;
  }
}
